.button {
  text-transform: none;
}

.button:global.MuiButton-root {
  border-radius: 0;
}

.button:global.MuiButton-sizeSmall {
  line-height: 1.5;
}

.button:global.MuiButton-sizeSmall.MuiButton-outlined {
  border-radius: 6px;
}

.button:global.MuiButton-sizeLarge {
  font-weight: 600;
}

.button:global.MuiButton-outlinedSecondary {
  color: white;
  border-color: white;
}
